import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import MasPanel from '../components/marketing/MasPanel';

/**
 * Marketing — the central M.A.S engine's surface for the selected
 * facility, rendered in M.A.S's own design language (the panel carries
 * its own header and module nav, so this page adds no chrome of its
 * own). Old ?view= deep links land here; lead-management redirects to
 * Leads.
 */
const MarketingSection = () => {
  const [searchParams] = useSearchParams();
  if (searchParams.get('view') === 'lead-management') {
    return <Navigate to="/reservations?tab=leads" replace />;
  }
  return <MasPanel />;
};

export default MarketingSection;
